module.exports = __webpack_public_path__ + "f3c70901c8d2cd9446744b477cc67713.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_recency_gray_2x.png
// module id = 126
// module chunks = 0 1 2 3 4